import { createFileRoute } from '@tanstack/react-router';
import { ComparePage } from '@/components/astro/new-design-25/compare/compare-page';
import * as m from '@/paraglide/messages';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute(
  '/_marketing/_seo/text-to-speech-app-comparison',
)({
  head: () => ({
    meta: [
      ...seo({
        title: m.meta_compare_title(),
        description: m.meta_compare_description(),
      }),
    ],
    links: [...hreflangLinks('/text-to-speech-app-comparison')],
  }),
  component: ComparePage,
});
